import { render, staticRenderFns } from "./ReqDocument.vue?vue&type=template&id=24df1a0b&scoped=true"
import script from "./ReqDocument.vue?vue&type=script&lang=js"
export * from "./ReqDocument.vue?vue&type=script&lang=js"
import style0 from "./ReqDocument.vue?vue&type=style&index=0&id=24df1a0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24df1a0b",
  null
  
)

export default component.exports